import { useEffect, useState } from "react";
import { navItems } from "@/mocks/content";

export default function SiteNav() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${
        scrolled
          ? "border-background-200 bg-background-50/90 backdrop-blur"
          : "border-transparent bg-background-50/70 backdrop-blur"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 items-center justify-between">
          <a href="#home" className="flex items-center gap-2 cursor-pointer">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-tv-2-line text-lg"></i>
            </span>
            <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
              韩剧TV
            </span>
          </a>

          <nav className="hidden items-center gap-1 md:flex">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#hot"
              className="hidden cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:flex"
            >
              <i className="ri-play-fill"></i>
              开始看剧
            </a>
            <button
              type="button"
              aria-label="打开导航菜单"
              aria-expanded={menuOpen}
              onClick={() => setMenuOpen((v) => !v)}
              className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-900 md:hidden"
            >
              <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <nav className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <div className="grid grid-cols-2 gap-2">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={() => setMenuOpen(false)}
                className="flex items-center gap-2 rounded-md bg-background-100 px-3 py-2.5 text-sm text-foreground-800 transition-colors hover:bg-background-200"
              >
                <i className="ri-arrow-right-s-line text-primary-500"></i>
                {item.label}
              </a>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
}